(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["add-on-accessories"] && !Shopify.designMode) return;
  try {
    
  class AddOnAccessoriesSection extends HTMLElement {
    constructor() {
      super();
      this.swatches = this.querySelectorAll('.add-on-accessories__swatch');
      this.variantInput = this.querySelector('.add-on-accessories__variant-input');
      this.priceElement = this.querySelector('.add-on-accessories__price-current');
      this.comparePriceElement = this.querySelector('.add-on-accessories__price-compare');
      this.selectedColorElement = this.querySelector('.add-on-accessories__selected-color');
      this.addButton = this.querySelector('.add-on-accessories__add-btn');
      this.mediaImage = this.querySelector('.add-on-accessories__media img');
      
      this.bindEvents();
    }
    
    bindEvents() {
      this.swatches.forEach(swatch => {
        swatch.addEventListener('click', (e) => this.handleSwatchClick(e));
      });
      
      const form = this.querySelector('.add-on-accessories__form');
      if (form) {
        form.addEventListener('submit', (e) => this.handleFormSubmit(e));
      }
    }
    
    handleSwatchClick(e) {
      const swatch = e.currentTarget;
      const variantId = swatch.dataset.variantId;
      const color = swatch.dataset.color;
      const price = swatch.dataset.price;
      const comparePrice = swatch.dataset.comparePrice;
      const available = swatch.dataset.available === 'true';
      const variantImage = swatch.dataset.variantImage;
      
      // Update active state
      this.swatches.forEach(s => s.classList.remove('is-active'));
      swatch.classList.add('is-active');
      
      // Update variant input
      if (this.variantInput) {
        this.variantInput.value = variantId;
      }
      
      // Update selected color text
      if (this.selectedColorElement) {
        this.selectedColorElement.textContent = color;
      }
      
      // Update price
      if (this.priceElement) {
        this.priceElement.textContent = price;
      }
      
      // Update compare price
      if (this.comparePriceElement) {
        if (comparePrice && comparePrice !== price) {
          this.comparePriceElement.textContent = comparePrice;
          this.comparePriceElement.style.display = '';
        } else {
          this.comparePriceElement.style.display = 'none';
        }
      }
      
      // Update button state
      if (this.addButton) {
        this.addButton.disabled = !available;
        this.addButton.textContent = available ? 'Add to Cart' : 'Sold Out';
      }
      
      // Update image
      if (variantImage && this.mediaImage) {
        this.mediaImage.src = variantImage;
      }
    }
    
    async handleFormSubmit(e) {
      e.preventDefault();
      
      const form = e.target;
      const formData = new FormData(form);
      
      this.addButton.disabled = true;
      this.addButton.textContent = 'Adding...';
      
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        });
        
        if (!response.ok) {
          throw new Error('Failed to add to cart');
        }
        
        this.addButton.textContent = 'Added!';
        
        // Dispatch cart update event
        document.dispatchEvent(new CustomEvent('cart:updated', {
          bubbles: true
        }));
        
        setTimeout(() => {
          this.addButton.disabled = false;
          this.addButton.textContent = 'Add to Cart';
        }, 2000);
        
      } catch (error) {
        console.error('Add to cart error:', error);
        this.addButton.disabled = false;
        this.addButton.textContent = 'Try Again';
      }
    }
  }
  
  customElements.define('add-on-accessories-section', AddOnAccessoriesSection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["filtered-collections"] && !Shopify.designMode) return;
  try {
    
  // Extract initialization logic into reusable function
  function initFilteredCollectionsSection(section) {
    const navItems = section.querySelectorAll('.filtered-collections__nav-item');
    const contentSections = section.querySelectorAll('[data-collection-content]');

    navItems.forEach(item => {
      item.addEventListener('click', function(event) {
        const clickedItem = event.currentTarget;
        const targetCollection = clickedItem.dataset.collection;

        // Update nav items
        navItems.forEach(navItem => {
          navItem.classList.remove('filtered-collections__nav-item--active');
        });
        clickedItem.classList.add('filtered-collections__nav-item--active');

        // Update content sections - hide all first
        contentSections.forEach(contentSection => {
          contentSection.classList.add('filtered-collections__content--hidden');

          // Hide slideshow slides for inactive collections
          const slides = contentSection.querySelectorAll('slideshow-slide');
          slides.forEach(slide => {
            slide.setAttribute('aria-hidden', 'true');
          });
        });

        // Show target collection content
        const targetContents = section.querySelectorAll(`[data-collection-content="${targetCollection}"]`);
        targetContents.forEach(targetContent => {
          targetContent.classList.remove('filtered-collections__content--hidden');

          // Fix aria-hidden attributes for slideshow slides
          const slides = targetContent.querySelectorAll('slideshow-slide');
          slides.forEach(slide => {
            slide.setAttribute('aria-hidden', 'false');
          });

          // Force load all images in the newly visible collection
          setTimeout(() => {
            // Find all images, including those with data-src attributes
            const allImages = targetContent.querySelectorAll('img, [data-src], picture source');
            allImages.forEach((img, index) => {
              // Handle data-src lazy loading
              if (img.dataset.src && !img.src) {
                img.src = img.dataset.src;
                img.removeAttribute('data-src');
              }

              // Handle srcset lazy loading
              if (img.dataset.srcset && !img.srcset) {
                img.srcset = img.dataset.srcset;
                img.removeAttribute('data-srcset');
              }

              // Force immediate loading
              img.setAttribute('loading', 'eager');
              img.removeAttribute('data-loading');

              // Remove lazy loading classes that might prevent loading
              img.classList.remove('lazyload', 'lazyloading', 'lazy');
              img.classList.add('lazyloaded');

              // Force visibility aggressively
              img.style.opacity = '1 !important';
              img.style.visibility = 'visible !important';
              img.style.display = 'block !important';
              img.style.width = 'auto !important';
              img.style.height = 'auto !important';
              img.style.maxWidth = '100% !important';
              img.style.position = 'static !important';
              img.style.left = 'auto !important';
              img.style.top = 'auto !important';

              // Trigger load event manually if src exists
              if (img.src && !img.complete) {
                const newImg = new Image();
                newImg.onload = () => {
                  if (!img.complete && newImg.src) {
                    img.src = newImg.src;
                  }
                };
                newImg.src = img.src;
              }
            });

            // Force check all product-specific image components
            const productCards = targetContent.querySelectorAll('product-card, .product-card, [data-product-id]');
            productCards.forEach((card, cardIndex) => {
              const images = card.querySelectorAll('img, [data-src], picture');
              images.forEach(img => {
                if (img.dataset.src && !img.src) {
                  img.src = img.dataset.src;
                  img.removeAttribute('data-src');
                }
                img.setAttribute('loading', 'eager');
                img.classList.remove('lazyload', 'lazyloading');
                img.classList.add('lazyloaded');
              });
            });

            // Multiple scroll events to trigger intersection observers
            ['scroll', 'resize', 'load'].forEach(eventType => {
              const event = new Event(eventType, { bubbles: true });
              window.dispatchEvent(event);
              document.dispatchEvent(event);
            });

            // Force trigger intersection observers with manual calls
            if (window.IntersectionObserver) {
              // Dispatch on all possible scroll containers
              const scrollContainers = [window, document, targetContent];
              scrollContainers.forEach(container => {
                const scrollEvent = new Event('scroll', { bubbles: true });
                container.dispatchEvent(scrollEvent);
              });
            }

            // Trigger theme lazy loading systems
            if (window.theme) {
              if (window.theme.lazyImages) {
                window.theme.lazyImages.check();
                // Force init again
                if (window.theme.lazyImages.init) window.theme.lazyImages.init();
              }
              if (window.theme.images) {
                window.theme.images.init();
                if (window.theme.images.load) window.theme.images.load();
              }
            }

            // Trigger lazySizes more aggressively
            if (window.lazySizes) {
              window.lazySizes.autoSizer.checkElems();
              if (window.lazySizes.loader) {
                window.lazySizes.loader.checkElems();
              }
              // Force recheck after a delay
              setTimeout(() => {
                window.lazySizes.autoSizer.checkElems();
              }, 50);
            }

            // Try to trigger Shopify theme image systems
            if (window.Shopify && window.Shopify.theme) {
              if (window.Shopify.theme.images) {
                window.Shopify.theme.images.init();
              }
            }

            // Images should now be visible
          }, 100);

          // Additional delayed check for stubborn images
          setTimeout(() => {
            const remainingLazyImages = targetContent.querySelectorAll('img[data-src], .lazyload');
            remainingLazyImages.forEach(img => {
              if (img.dataset.src && !img.src) {
                img.src = img.dataset.src;
                img.removeAttribute('data-src');
                img.classList.remove('lazyload');
                img.classList.add('lazyloaded');
              }
            });
          }, 300);
        });
      });
    });
  }

  // Initialize on page load
  document.addEventListener('DOMContentLoaded', function() {
    const sections = document.querySelectorAll('.ui-test-filtered-collections');
    sections.forEach(section => {
      initFilteredCollectionsSection(section);
    });
  });

  // Handle section reload in customizer
  document.addEventListener('shopify:section:load', function(event) {
    if (event.target.classList.contains('ui-test-filtered-collections')) {
      // Reinitialize the filtered collections functionality
      setTimeout(() => {
        initFilteredCollectionsSection(event.target);
      }, 100);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["filtered-products"] && !Shopify.designMode) return;
  try {
    
  // Extract initialization logic into reusable function
  function initFilteredCollectionsSection(section) {
    const navItems = section.querySelectorAll('.filtered-collections__nav-item');
    const contentSections = section.querySelectorAll('[data-collection-content]');

    navItems.forEach(item => {
      item.addEventListener('click', function(event) {
        const clickedItem = event.currentTarget;
        const targetCollection = clickedItem.dataset.collection;

        // Update nav items
        navItems.forEach(navItem => {
          navItem.classList.remove('filtered-collections__nav-item--active');
        });
        clickedItem.classList.add('filtered-collections__nav-item--active');

        // Update content sections - hide all first
        contentSections.forEach(contentSection => {
          contentSection.classList.add('filtered-collections__content--hidden');

          // Hide slideshow slides for inactive collections
          const slides = contentSection.querySelectorAll('slideshow-slide');
          slides.forEach(slide => {
            slide.setAttribute('aria-hidden', 'true');
          });
        });

        // Show target collection content
        const targetContents = section.querySelectorAll(`[data-collection-content="${targetCollection}"]`);
        targetContents.forEach(targetContent => {
          targetContent.classList.remove('filtered-collections__content--hidden');

          // Fix aria-hidden attributes for slideshow slides
          const slides = targetContent.querySelectorAll('slideshow-slide');
          slides.forEach(slide => {
            slide.setAttribute('aria-hidden', 'false');
          });

          // Force load all images in the newly visible collection
          setTimeout(() => {
            // Find all images, including those with data-src attributes
            const allImages = targetContent.querySelectorAll('img, [data-src], picture source');
            allImages.forEach((img, index) => {
              // Handle data-src lazy loading
              if (img.dataset.src && !img.src) {
                img.src = img.dataset.src;
                img.removeAttribute('data-src');
              }

              // Handle srcset lazy loading
              if (img.dataset.srcset && !img.srcset) {
                img.srcset = img.dataset.srcset;
                img.removeAttribute('data-srcset');
              }

              // Force immediate loading
              img.setAttribute('loading', 'eager');
              img.removeAttribute('data-loading');

              // Remove lazy loading classes that might prevent loading
              img.classList.remove('lazyload', 'lazyloading', 'lazy');
              img.classList.add('lazyloaded');

              // Force visibility aggressively
              img.style.opacity = '1 !important';
              img.style.visibility = 'visible !important';
              img.style.display = 'block !important';
              img.style.width = 'auto !important';
              img.style.height = 'auto !important';
              img.style.maxWidth = '100% !important';
              img.style.position = 'static !important';
              img.style.left = 'auto !important';
              img.style.top = 'auto !important';

              // Trigger load event manually if src exists
              if (img.src && !img.complete) {
                const newImg = new Image();
                newImg.onload = () => {
                  if (!img.complete && newImg.src) {
                    img.src = newImg.src;
                  }
                };
                newImg.src = img.src;
              }
            });

            // Force check all product-specific image components
            const productCards = targetContent.querySelectorAll('product-card, .product-card, [data-product-id]');
            productCards.forEach((card, cardIndex) => {
              const images = card.querySelectorAll('img, [data-src], picture');
              images.forEach(img => {
                if (img.dataset.src && !img.src) {
                  img.src = img.dataset.src;
                  img.removeAttribute('data-src');
                }
                img.setAttribute('loading', 'eager');
                img.classList.remove('lazyload', 'lazyloading');
                img.classList.add('lazyloaded');
              });
            });

            // Multiple scroll events to trigger intersection observers
            ['scroll', 'resize', 'load'].forEach(eventType => {
              const event = new Event(eventType, { bubbles: true });
              window.dispatchEvent(event);
              document.dispatchEvent(event);
            });

            // Force trigger intersection observers with manual calls
            if (window.IntersectionObserver) {
              // Dispatch on all possible scroll containers
              const scrollContainers = [window, document, targetContent];
              scrollContainers.forEach(container => {
                const scrollEvent = new Event('scroll', { bubbles: true });
                container.dispatchEvent(scrollEvent);
              });
            }

            // Trigger theme lazy loading systems
            if (window.theme) {
              if (window.theme.lazyImages) {
                window.theme.lazyImages.check();
                // Force init again
                if (window.theme.lazyImages.init) window.theme.lazyImages.init();
              }
              if (window.theme.images) {
                window.theme.images.init();
                if (window.theme.images.load) window.theme.images.load();
              }
            }

            // Trigger lazySizes more aggressively
            if (window.lazySizes) {
              window.lazySizes.autoSizer.checkElems();
              if (window.lazySizes.loader) {
                window.lazySizes.loader.checkElems();
              }
              // Force recheck after a delay
              setTimeout(() => {
                window.lazySizes.autoSizer.checkElems();
              }, 50);
            }

            // Try to trigger Shopify theme image systems
            if (window.Shopify && window.Shopify.theme) {
              if (window.Shopify.theme.images) {
                window.Shopify.theme.images.init();
              }
            }

            // Images should now be visible
          }, 100);

          // Additional delayed check for stubborn images
          setTimeout(() => {
            const remainingLazyImages = targetContent.querySelectorAll('img[data-src], .lazyload');
            remainingLazyImages.forEach(img => {
              if (img.dataset.src && !img.src) {
                img.src = img.dataset.src;
                img.removeAttribute('data-src');
                img.classList.remove('lazyload');
                img.classList.add('lazyloaded');
              }
            });
          }, 300);
        });
      });
    });
  }

  // Initialize on page load
  document.addEventListener('DOMContentLoaded', function() {
    const sections = document.querySelectorAll('.ui-test-filtered-products');
    sections.forEach(section => {
      initFilteredCollectionsSection(section);
    });
  });

  // Handle section reload in customizer
  document.addEventListener('shopify:section:load', function(event) {
    if (event.target.classList.contains('ui-test-filtered-products')) {
      // Reinitialize the filtered collections functionality
      setTimeout(() => {
        initFilteredCollectionsSection(event.target);
      }, 100);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
